import React from 'react';
import './EmpowerSection.css';


const About2 = () => {
  return (
    <section className="about2-section">
      <div className="about2-container">
        <div className="about2-grid">
          {/* Left Column */}
          <div className="about2-text">
            <h1 className="about2-title">
              Supporting the Next Generation of Quantum Innovators
            </h1>
            <p className="about2-description">
            Quantumke is the leading quantum science and technology community in Kenya, uniting researchers, industry experts, academics, and enthusiasts who are passionate about shaping the future of quantum technologies. Since 2021, we have championed research, education, inclusive access to quantum computing, and the development of applications, while serving as a neutral platform for collaboration across academia, industry, and policy in Kenya’s quantum ecosystem.
            </p>
          </div>
          
          {/* Right Column - Video */}
          <div className="about2-video-container">
            <iframe 
              className="about2-video"
              src="https://www.youtube.com/embed/qIGiZWNh-Bs?si=RHFwYCyjp9a8rDMz"
              title="Promotional Video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About2;
